// Route paths shared by the router table, tab navigation, and view links.
export const THIS_PAGE_PATH = '/extension';
export const BUCKETS_PATH = '/extension/buckets';
export const SUPER_COPY_PATH = '/extension/buckets/super-copy';
export const WORKSPACES_PATH = '/extension/workspaces';
export const SETTINGS_PATH = '/extension/settings';

export function workspaceGeneratePath(workspaceId: string): string {
  return `${WORKSPACES_PATH}?generate=${encodeURIComponent(workspaceId)}`;
}

export function bucketPath(bucketId: string): string {
  return `${BUCKETS_PATH}/${encodeURIComponent(bucketId)}`;
}
